import React from "react";

/* ── Asset imports ── */
import HeroBgImg         from "../../asset/images/news/TransformerBushingsCoalPowerHero-bg.webp";
import ArticleImg        from "../../asset/images/news/article-40.webp";
import YoutubeIcon       from "../../asset/images/news/icon-youtube.svg";
import LinkedinIcon      from "../../asset/images/news/icon-linkedin.svg";
import BcSepIcon         from "../../asset/images/news/breadcrumb-separator.svg";
import ProfileIcon       from "../../asset/images/news/icon-profile.svg";
import CalendarIcon      from "../../asset/images/news/icon-calendar.svg";
import ClockIconImg      from "../../asset/images/news/icon-clock.svg";
import CommentsIcon      from "../../asset/images/news/icon-comments.svg";
import PreviousIcon      from "../../asset/images/news/icon-previous.svg";
import NextIcon          from "../../asset/images/news/icon-next.svg";
import FacebookIcon      from "../../asset/images/news/icon-facebook.svg";
import TwitterIcon       from "../../asset/images/news/icon-twitter.svg";
import LinkedinShareIcon from "../../asset/images/news/icon-linkedin-share.svg";

/* ── Recent post thumbnails ── */
import RecentImg1 from "../../asset/images/news/news-1.webp";
import RecentImg2 from "../../asset/images/news/news-2.webp";
import RecentImg3 from "../../asset/images/news/news-3.webp";
import RecentImg4 from "../../asset/images/news/news-4.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .tbcp { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══ HERO ══ */
  .tbcp-hero {
    position: relative; width: 100%; height: 460px;
    overflow: hidden;
  }
  .tbcp-hero-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover; object-position: center right; display: block;
  }
  .tbcp-hero-overlay {
    position: absolute; inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.85) 0%,
    //   rgba(0,0,0,0.65) 38%,
    //   rgba(0,0,0,0.10) 100%
    // );
  }
  .tbcp-hero-content {
    position: absolute; inset: 0;
    display: flex; flex-direction: column; justify-content: center;
    padding: 0 102px;
    max-width: 1600px; margin: 0 auto; left: 0; right: 0;
  }
  .tbcp-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px; font-weight: 600; color: #fff;
    line-height: 120%; margin-bottom: 15px; max-width: 575px;
  }
  .tbcp-hero-divider {
    width: 575px; height: 2px;
    background: #EB2019; border: none; margin-bottom: 15px;
  }
  .tbcp-hero-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #fff;
    line-height: 160%; max-width: 479px;
  }

  /* ══ BREADCRUMB ══ */
  .tbcp-breadcrumb { width: 100%; padding: 40px 0 0 0; }
  .tbcp-breadcrumb-inner {
    max-width: 1600px; margin: 0 auto; padding: 0 102px;
    display: flex; align-items: center; flex-wrap: wrap;
  }
  .tbcp-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 500; color: #202020;
    text-decoration: none; display: flex; align-items: center; gap: 14px;
    transition: color 0.15s;
  }
  .tbcp-bc-item:hover { color: #EB2019; }
  .tbcp-bc-sep {
    display: flex; align-items: center; justify-content: center;
    width: 24px; height: 24px; border-radius: 50%;
    margin: 0 8px; flex-shrink: 0;
  }
  .tbcp-bc-sep img { width: 24px; height: 24px; display: block; }
  .tbcp-bc-item.active { color: #202020; font-weight: 500; }

  /* ══ INNER ══ */
  .tbcp-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; }

  /* ══ MAIN ══ */
  .tbcp-main-section { padding: 80px 0 120px 0; }
  .tbcp-main-row { display: flex; align-items: flex-start; gap: 89px; }

  /* ══ ARTICLE ══ */
  .tbcp-article { flex: 1; min-width: 0; }

  .tbcp-meta-bar {
    display: flex; align-items: center; flex-wrap: wrap; gap: 20px;
    margin-bottom: 30px;
  }
  .tbcp-meta-item {
    display: flex; align-items: center; gap: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    border-right: 1px solid #7A7A7A; padding-right: 15px;
  }
  .tbcp-meta-item:last-child { border-right: none; padding-right: 0; }
  .tbcp-meta-item img { width: 24px; height: 24px; display: block; flex-shrink: 0; }

  .tbcp-article-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px; font-weight: 600; color: #202020;
    line-height: 140%; margin-bottom: 30px;
  }

  .tbcp-article-img {
    width: 100%; height: 450px;
    object-fit: cover; border-radius: 10px;
    display: block; margin: 45px 0 30px 0;
  }

  .tbcp-article-body {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .tbcp-article-body p { margin-bottom: 20px; }
  .tbcp-article-body p:last-child { margin-bottom: 0; }

  .tbcp-h2 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 0px 0 0px 0; line-height: 160%; display: block;
  }

  .tbcp-article-body strong { font-weight: 600; color: #202020; }

  .tbcp-red-link {
    color: #EB2019; text-decoration: underline; font-weight: 600;
    display: block; margin-bottom: 20px;
  }
  .tbcp-red-link:hover { opacity: 0.8; }

  .tbcp-red-link-plain { color: #EB2019; text-decoration: underline; font-weight: 600; }
  .tbcp-red-link-plain:hover { opacity: 0.8; }

  /* Hashtags */
  .tbcp-hashtags {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 700; color: #202020;
    line-height: 160%; margin-top: 15px;
  }

  /* ══ BOTTOM ROW ══ */
  .tbcp-bottom-row {
    display: flex; align-items: center; justify-content: space-between;
    margin-top: 30px; padding-top: 30px;
    border-top: 1px solid #C7C7C7; flex-wrap: wrap; gap: 16px;
  }
  .tbcp-bottom-nav { display: flex; align-items: center; gap: 60px; }
  .tbcp-nav-btn {
    display: inline-flex; align-items: center; gap: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px; font-weight: 500; color: #202020;
    text-decoration: none; background: none; border: none;
    cursor: pointer; transition: color 0.15s;
  }
  .tbcp-nav-btn:hover { color: #EB2019; }
  .tbcp-nav-btn img { width: 40px; height: 40px; display: block; }

  .tbcp-share-icons { display: flex; align-items: center; gap: 20px; }
  .tbcp-share-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 50%;
    text-decoration: none; flex-shrink: 0; transition: opacity 0.15s;
  }
  .tbcp-share-icon:hover { opacity: 0.85; }
  .tbcp-share-icon img { width: 44px; height: 44px; display: block; }

  /* ══ SIDEBAR ══ */
  .tbcp-sidebar { flex: 0 0 475px; }
  .tbcp-sidebar-block { margin-bottom: 60px; }
  .tbcp-sidebar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px; font-weight: 600; color: #202020;
    margin-bottom: 30px; padding-bottom: 20px;
    border-bottom: 1px solid #EB2019; line-height: 120%;
  }
  .tbcp-recent-list { display: flex; flex-direction: column; gap: 30px; }
  .tbcp-recent-item {
    display: flex; align-items: flex-start; gap: 12px;
    text-decoration: none; color: #202020;
  }
  .tbcp-recent-item:hover .tbcp-recent-title { color: #EB2019; }
  .tbcp-recent-img {
    flex: 0 0 200px; height: 120px;
    object-fit: cover; border-radius: 6px; display: block;
  }
  .tbcp-recent-body { flex: 1; min-width: 0; }
  .tbcp-recent-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; transition: color 0.15s;
    display: -webkit-box; -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; overflow: hidden;
  }
  .tbcp-social-icons { display: flex; align-items: center; gap: 30px; }
  .tbcp-social-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 6px; overflow: hidden;
    text-decoration: none; transition: opacity 0.15s;
  }
  .tbcp-social-icon:hover { opacity: 0.8; }
  .tbcp-social-icon img { width: 44px; height: 44px; object-fit: contain; display: block; }

  /* ══ RESPONSIVE — TABLET ══ */
  @media (max-width: 768px) {
    .tbcp-hero             { height: 350px; }
    .tbcp-hero-content     { padding: 0 32px; }
    .tbcp-hero-title       { font-size: 30px; }
    .tbcp-hero-divider     { width: 100%; max-width: 479px; }
    .tbcp-breadcrumb       { padding: 24px 0 0 0; }
    .tbcp-breadcrumb-inner { padding: 0 32px; }
    .tbcp-inner            { padding: 0 32px; }
    .tbcp-main-section     { padding: 48px 0 60px 0; }
    .tbcp-main-row         { flex-direction: column; gap: 48px; }
    .tbcp-sidebar          { flex: none; width: 100%; }
    .tbcp-article-title    { font-size: 20px; }
  }

  /* ══ RESPONSIVE — MOBILE ══ */
  @media (max-width: 480px) {
    .tbcp-hero             { height: 360px; }
    .tbcp-hero-content     { padding: 0 16px; }
    .tbcp-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .tbcp-hero-divider     { width: 100%; }
    .tbcp-hero-subtitle    { font-size: 14px; }
    .tbcp-breadcrumb       { padding: 30px 0 0 0; }
    .tbcp-breadcrumb-inner { padding: 0 16px; }
    .tbcp-bc-item          { font-size: 14px; gap: 14px; }
    .tbcp-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .tbcp-bc-sep img       { width: 22px; height: 22px; }
    .tbcp-inner            { padding: 0 16px; }
    .tbcp-main-section     { padding: 30px 0 60px 0; }
    .tbcp-main-row         { flex-direction: column; gap: 60px; }
    .tbcp-sidebar          { flex: none; width: 100%; }
    .tbcp-article-title    { font-size: 20px; margin-bottom: 15px; }
    .tbcp-article-body     { font-size: 14px; }
    .tbcp-article-body p   { margin-bottom: 15px; }
    .tbcp-article-body strong { font-size: 16px; }
    .tbcp-meta-item        { font-size: 14px; }
    .tbcp-meta-item:nth-child(3) { border-right: none; padding-right: 0; }
    .tbcp-article-img      { margin: 30px 0 15px 0; height: 250px; }
    .tbcp-h2               { font-size: 16px; margin: 30px 0 0px 0; }
    .tbcp-hashtags         { margin-top: 30px; font-size: 14px; }
    .tbcp-nav-btn img      { width: 24px; height: 24px; }
    .tbcp-nav-btn          { font-size: 14px; }
    .tbcp-share-icon img   { width: 34px; height: 34px; }
    .tbcp-sidebar-title    { font-size: 20px; }
    .tbcp-bottom-nav       { gap: 20px; }
  }
`;

const recentPosts = [
   {
       img: RecentImg1,
       title: "Battery Formation & Testing: Enabling The Rise Of EV & Energy Storage Manufacturing",
       slug: "battery-formation-testing-enabling-the-rise-of-ev-energy-storage-manufacturing/",
     },
     {
       img: RecentImg2,
       title: "Next-Gen ESP Power Supplies: Upgrades and Sustainability in Industrial Air Pollution Control",
       slug: "next-gen-esp-power-supplies-upgrades-and-sustainability-in-industrial-air-pollution-control/",
     },
     {
       img: RecentImg3,
       title: "Green Hydrogen Power Electronics: Ador Powertron at the Forefront of Electrolyzer Rectifier Setups",
       slug: "green-hydrogen-power-electronics-ador-powertron-at-the-forefront-of-electrolyzer-rectifier-setups/",
     },
     {
       img: RecentImg4,
       title: "Transformer Bushings: Types & Importance",
       slug: "transformer-bushings-guide/",
     },

];

export default function TransformerBushingsCoalPower() {
  return (
    <div className="tbcp">
      <style>{CSS}</style>

      {/* ══ HERO ══ */}
      <section className="tbcp-hero">
        <img className="tbcp-hero-bg" src={HeroBgImg} alt="How Transformer Bushings Impact Power Plant Efficiency and Safety Hero" />
        <div className="tbcp-hero-overlay" />
        <div className="tbcp-hero-content">
          <h1 className="tbcp-hero-title">
            How Transformer Bushings Impact Power Plant Efficiency and Safety: A Focus on Coal-Fired Power Plants
          </h1>
          <hr className="tbcp-hero-divider" />
          <p className="tbcp-hero-subtitle">
            Everything we do is designed, whether we're producing a magazine, a website, or a bridge. Design is really the creative invention that designs everything.
          </p>
        </div>
      </section>

      {/* ══ BREADCRUMB ══ */}
      <nav className="tbcp-breadcrumb" aria-label="Breadcrumb">
        <div className="tbcp-breadcrumb-inner">
          <a href="/" className="tbcp-bc-item">Home</a>
          <span className="tbcp-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/news" className="tbcp-bc-item">News &amp; Updates</a>
          <span className="tbcp-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="tbcp-bc-item active">Post</span>
        </div>
      </nav>

      {/* ══ MAIN ══ */}
      <section className="tbcp-main-section">
        <div className="tbcp-inner">
          <div className="tbcp-main-row">

            {/* ── ARTICLE ── */}
            <article className="tbcp-article">

              {/* Meta bar */}
              <div className="tbcp-meta-bar">
                <span className="tbcp-meta-item"><img src={ProfileIcon} alt="author" /> Admin</span>
                <span className="tbcp-meta-item"><img src={CalendarIcon} alt="date" /> October 4, 2024</span>
                <span className="tbcp-meta-item"><img src={ClockIconImg} alt="time" /> 4:53 am</span>
                <span className="tbcp-meta-item"><img src={CommentsIcon} alt="comments" /> No Comments</span>
              </div>

              {/* Title */}
              <h1 className="tbcp-article-title">
                How Transformer Bushings Impact Power Plant Efficiency and Safety: A Focus on Coal-Fired Power Plants
              </h1>

              {/* Body */}
              <div className="tbcp-article-body">

                <p>In coal-fired power plants, <strong>transformer bushings</strong> are crucial components that ensure safe and efficient electrical transmission. They provide electrical insulation where conductors pass through ground barriers, such as transformer walls. Given the complex and demanding conditions in these plants, maintaining the optimal performance of <strong>transformer bushings</strong> is essential for both operational efficiency and safety.</p>

                {/* Article image */}
                <img className="tbcp-article-img" src={ArticleImg} alt="Transformer Bushings Coal-Fired Power Plants" />

                <p>This blog will investigate how <strong>transformer bushings</strong> affect power plant efficiency and security, mainly concentrating on coal-fired power plants.</p>

                <span className="tbcp-h2">1.Ensuring Electrical Insulation</span>

                <p>One of the immediate roles of <a href="/products/" className="tbcp-red-link-plain">transformer bushings</a> is to deliver sufficient electrical insulation, which guarantees the uninterrupted discharge of electricity via transformers. In coal-fired power plants, where high-voltage systems are continuously functioning, defective bushings can usher to short circuits, electrical discharge, or even transformer failure. Adequately sustained transformer bushings decrease the chance of such problems, guaranteeing smooth power transmission and plant efficiency.</p>

                <span className="tbcp-h2">2.Enhancing Power Plant Efficiency</span>

                <p>High-performance transformer bushings contribute to overall plant efficiency by minimizing electrical losses. Poor insulation or degradation of bushings can yield energy leaks, decreasing the power plant's all-around efficiency. By regularly examining and sustaining transformer bushings, coal-fired power plants can minimize energy loss and guarantee the highest power output.</p>

                <p>Also, bushings designed for high-voltage applications are especially valuable for coal power plants, as they support and sustain the critical power levels for functions, leading to more suitable energy utilization and descending functional costs.</p>

                <span className="tbcp-h2">3.Enhancing Safety Standards</span>

                <p>Safety is essential in power plant operations, and transformer bushings support secure operational conditions. A harmed or spoiled bushing can lead to hazardous electrical faults, which may damage equipment or even threaten human safety.</p>

                <p>Routine maintenance and punctual alternate transformer bushings can help prevent catastrophic losses, guaranteeing safety for equipment and personnel. You can integrate progressive monitoring systems to notice early signs of bushing wear and tear, allowing for proactive supervision and decreasing the probability of security incidents.</p>

                <span className="tbcp-h2">4.Durability in Extreme Conditions</span>

                <p>Coal-fired power plants usually function under extreme environmental situations, with high temperatures, humidity, and vulnerability to pollutants. <strong>Transformer bushings</strong> are designed to resist these conditions while retaining their insulating properties. Picking high-quality <strong>transformer bushings</strong> engineered for durability guarantees longer service life and short, frequent replacements, instantly affecting the plant's functional dependability and cost-effectiveness.</p>

                <span className="tbcp-h2">5.Averting Downtime</span>

                <p>Power plant downtime can be expensive in terms of lost income and the possibility of equipment damage. Defective or worn <strong>transformer bushings</strong> can be a substantial cause of unexpected outages. By integrating a potent bushing maintenance schedule and leveraging high-quality <strong>transformer bushings</strong> from trustworthy manufacturers like <strong>ADOR POWERTRON</strong>, coal-fired power plants can minimize downtime, guaranteeing continued function and improving overall productivity.</p>

                <span className="tbcp-h2">In a Nutshell</span>

                <p>Transformer bushings are critical to maintaining a plant's operational efficiency and ensuring safety standards in coal-fired power plants. High-quality bushings, such as resin-impregnated paper (RIP) and condenser bushings, play a key role in insulating high-voltage conductors and managing the electric field effectively. Routine inspections, accurate maintenance, and durable bushings are vital to preventing partial discharges, controlling equipment losses, minimizing downtime, and optimizing energy output.</p>

                <p>AdorPowertron, with its extensive experience and commitment to quality, offers industry-leading transformer bushings designed to meet the rigorous demands of coal-fired power plants.Take action toward enhancing your plant's efficiency and security now.</p>

                <a href="/contact-us" className="tbcp-red-link">Contact us for expert solutions tailored to your power plant needs.</a>

                <p className="tbcp-hashtags"><strong>#TransformerBushings #PowerPlantEfficiency #CoalFiredPowerPlants #EnergyEfficiency #SafetyStandards #ElectricalInsulation #AdorPowertron</strong></p>

              </div>

              {/* ── Bottom row ── */}
              <div className="tbcp-bottom-row">
                <div className="tbcp-bottom-nav">
                  <a href="/news/designing-efficient-smps-coal" className="tbcp-nav-btn">
                    <img src={PreviousIcon} alt="Previous" />
                    Previous
                  </a>
                  <a href="/news/maximizing-efficiency-esp-coal" className="tbcp-nav-btn">
                    Next
                    <img src={NextIcon} alt="Next" />
                  </a>
                </div>
                <div className="tbcp-share-icons">
                  <a href="https://www.facebook.com/sharer.php?u=https://adorpowertron.com/transformer-bushings-impact-power-plant-efficiency/" className="tbcp-share-icon" aria-label="Facebook" target="blank">
                    <img src={FacebookIcon} alt="Facebook" />
                  </a>
                  <a href="https://x.com/i/jf/onboarding/web?redirect_after_login=%2Fintent%2Ftweet%3Ftext%3D%2520https%3A%2F%2Fadorpowertron.com%2Ftransformer-bushings-impact-power-plant-efficiency%2F&mode=login" className="tbcp-share-icon" aria-label="Twitter" target="blank">
                    <img src={TwitterIcon} alt="Twitter" />
                  </a>
                  <a href="https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2FshareArticle%3Fmini%3Dtrue%26url%3Dhttps%3A%2F%2Fadorpowertron.com%2Ftransformer-bushings-impact-power-plant-efficiency%2F%26title%3DFocus%2520on%2520Coal-Fired%2520Power%2520Plants%2520%257C%2520Ador%26summary%3D%26source%3Dhttps%3A%2F%2Fadorpowertron.com%2Ftransformer-bushings-impact-power-plant-efficiency%2F" className="tbcp-share-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinShareIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </article>

            {/* ── SIDEBAR ── */}
            <aside className="tbcp-sidebar">

              {/* Recent Posts */}
              <div className="tbcp-sidebar-block">
                <p className="tbcp-sidebar-title">Recent Posts</p>
                <div className="tbcp-recent-list">
                  {recentPosts.map((post, idx) => (
                    <a key={idx} href={`/news/${post.slug}`} className="tbcp-recent-item">
                      <img src={post.img} alt={post.title} className="tbcp-recent-img" />
                      <div className="tbcp-recent-body">
                        <span className="tbcp-recent-title">{post.title}</span>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="tbcp-sidebar-block">
                <p className="tbcp-sidebar-title">Social Media</p>
                <div className="tbcp-social-icons">
                  <a href="https://www.youtube.com/@adorIndia" className="tbcp-social-icon" aria-label="YouTube" target="blank">
                    <img src={YoutubeIcon} alt="YouTube" />
                  </a>
                  <a href="https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2F139191%2Fadmin%2F" className="tbcp-social-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </aside>

          </div>
        </div>
      </section>

    </div>
  );
}